export default "__VITE_ASSET__CXI3rIAF__"